module.exports = __webpack_public_path__ + "static/media/kwayteow.449aa736.webp";